import { Reducer } from 'redux';
import { Actions } from '../actions/Actions';

/**
 * Client-only feature-flag state for the server-driven forms preview. Lives in the app's Redux store
 * (in-memory only — intentionally NOT persisted to localStorage/cookies, so a page reload resets the
 * flags to their defaults). Read/written through the synchronous facade in `src/Common/featureFlags`.
 */
export interface FeatureFlagsState {
  /** Opt into the server-driven create forms (RoB, AOAI). */
  serverDrivenForms: boolean;
  /** Escape hatch: revert the server-driven forms to recompute-on-every-edit (disables reactive gating). */
  legacyRecompute: boolean;
}

export const initialFeatureFlagsState: FeatureFlagsState = {
  serverDrivenForms: false,
  legacyRecompute: false,
};

export const reducer: Reducer<FeatureFlagsState> = (
  oldState: FeatureFlagsState = initialFeatureFlagsState,
  action: any
): FeatureFlagsState => {
  switch (action.type) {
    case Actions.SET_SERVER_DRIVEN_FORMS_FLAG:
      return { ...oldState, serverDrivenForms: action.payload === true };
    case Actions.SET_LEGACY_RECOMPUTE_FLAG:
      return { ...oldState, legacyRecompute: action.payload === true };
    default:
      return oldState;
  }
};

export const setServerDrivenForms = (payload: boolean) => ({
  type: Actions.SET_SERVER_DRIVEN_FORMS_FLAG,
  payload,
});

export const setLegacyRecompute = (payload: boolean) => ({
  type: Actions.SET_LEGACY_RECOMPUTE_FLAG,
  payload,
});
// Generated by GitHub Copilot | Updated on: 2026-07-22 | Removed serverDrivenManageForms flag (state + reducer case + action creator): Marketplace manage form is no longer flag-gated, visibility is controlled by the MarketplaceTenant flight instead
// Generated by GitHub Copilot | Updated on: 2026-07-21 | 12 lines added | Added serverDrivenManageForms flag (state + initial + reducer case + action creator) for the Marketplace manage server-driven form
// Generated by GitHub Copilot | Created on: 2026-07-21 | New file | In-memory Redux reducer for server-driven-forms + legacy-recompute feature flags (replaces localStorage)
